import React, { useState, useCallback, useRef } from 'react'
import styled, { css } from 'styled-components'
import { withAssetPrefix } from 'gatsby'
import { MqTablet, MqDesktop } from 'streamr-ui/css/consts'
import PlayButton, { DarkTheme } from '~shared/PlayButton'
import getVideoURL from '~utils/getVideoURL'

export const Wrapper = styled.div`
    padding: 0 16px;

    @media ${MqTablet} {
        padding: 0 32px;
    }

    @media ${MqDesktop} {
        padding: 0 24px;
    }
`

const Video = styled.video`
    aspect-ratio: 16 / 9;
    display: block;
    width: 100%;

    ${({ $active }) =>
        !$active &&
        css`
            display: none;
        `}
`

const playVideo = async (video) => {
    if (video) {
        try {
            await video.play()
        } catch (e) {
            // Video could not be played.
        }
    }
}

const Source = ({ study, suffix = '' }) => (
    <source src={withAssetPrefix(getVideoURL(`${study}_1472${suffix}.mp4`))} type="video/mp4" />
)

const UnstyledCaseStudyVideo = ({ className, study, poster, ...props }) => {
    const [playSample, setPlaySample] = useState(true)

    const videoRef = useRef()

    const onClick = useCallback(() => {
        setPlaySample(false)
        playVideo(videoRef.current)
    }, [])

    return (
        <div {...props} className={className} $appear>
            {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
            {!!playSample && (
                <Video $active autoPlay loop muted playsInline poster={poster} preload="metadata">
                    <Source study={study} suffix=".short" />
                </Video>
            )}
            <Video
                $active={!playSample}
                playsInline
                controls
                poster={poster}
                preload="metadata"
                ref={videoRef}
            >
                <Source study={study} />
            </Video>
            {playSample && <PlayButton theme={DarkTheme} onClick={onClick} />}
        </div>
    )
}

const CaseStudyVideo = styled(UnstyledCaseStudyVideo)`
    margin: 0 auto;
    max-width: 1432px;
    position: relative;
`

export default CaseStudyVideo
